<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h1" v-t="'modal.accessible_zone.title'"/>
    </template>
    <template slot="default">
      <p v-t="'modal.accessible_zone.message'"/>
    </template>
    <template slot="footer">
      <button class="btn--inverted"
        v-t="'buttons.ok'"
        @click="advisoryConfirmed"/>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";

export default {
  name: "modal-accessible-zone",
  components: {
    ModalTemplate,
  },
  data() {
    return {
      modalName: "modal-accessible-zone",
    };
  },
  methods: {
    advisoryConfirmed() {
      this.$emit("advisoryConfirmed");
      this.$modal.hide(this.modalName);
    },
  },
};
</script>
